module.exports = __webpack_public_path__ + "images/icons_v2/chat-outlined-919663b0.svg";